import React from 'react';
import { Globe, CheckCircle } from 'lucide-react';
import { EditableText } from './inline/EditableText';

const FeaturedNationSection = ({ content, sectionId }) => {
  const data = {
    title: '2026 Allied Nation',
    nation_name: '',
    flag_url: null,
    description: '',
    highlights: [],
    ...content,
  };
  const scope = (path) => ({ type: 'homepage_section', sectionId, path });

  if (!data.nation_name) return null;

  return (
    <section className="py-20 bg-gradient-to-br from-[#00457f] to-[#003461] text-white" data-testid="section-featured-nation">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Globe className="w-4 h-4 text-amber-400" />
            <span className="text-xs font-bold uppercase tracking-widest text-amber-400">
              <EditableText as="span" scope={scope('title')} value={data.title} multiline={false}>{data.title}</EditableText>
            </span>
          </div>
          <div className="flex items-center justify-center gap-5">
            {data.flag_url && (
              <img
                src={data.flag_url}
                alt={`${data.nation_name} flag`}
                className="h-12 md:h-16 w-auto rounded shadow-lg"
              />
            )}
            <h2 className="text-4xl md:text-6xl font-bold tracking-tight">
              <EditableText as="span" scope={scope('nation_name')} value={data.nation_name} multiline={false}>{data.nation_name}</EditableText>
            </h2>
          </div>
        </div>

        {data.description && (
          <p className="text-base md:text-lg text-white/80 leading-relaxed text-center max-w-3xl mx-auto mb-12">
            <EditableText as="span" scope={scope('description')} value={data.description}>{data.description}</EditableText>
          </p>
        )}

        {data.highlights && data.highlights.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
            {data.highlights.map((item, idx) => (
              <div
                key={idx}
                className="flex items-start gap-3 bg-white/5 backdrop-blur-sm rounded-xl p-5 border border-white/10"
                data-testid={`nation-highlight-${idx}`}
              >
                <CheckCircle className="w-5 h-5 text-amber-400 mt-0.5 shrink-0" />
                <span className="text-white/90 text-sm md:text-base">
                  {typeof item === 'string' ? item : item.text || item.title || ''}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedNationSection;
